module.exports = __webpack_public_path__ + "media/sg_RM3.22142381.mp4";